<template>
  <div role="navigation" class="navbar">
    <ul role="menubar" class="navbar__menu" v-click-outside="closeItem">
      <li
        @mouseover="!isMobile ? toggleItem(idx) : false"
        @mouseleave="!isMobile ? closeItem() : false"
        v-for="(parentItem, idx) in items"
        :key="idx"
        class="navbar__menu-item"
        role="none"
      >
        <a
          @click="isMobile ? toggleItem(idx, $event) : false"
          :href="getMenuLink(parentItem.item[0].link)"
          :class="{ _active: toggle.indexOf(idx) >= 0 }"
          role="menuitem"
          >{{ parentItem.item[0].nazwa }}</a
        >
        <div
          v-if="parentItem.item.length > 1"
          :class="{ _open: toggle.indexOf(idx) >= 0 }"
          class="navbar__submenu-wrapper"
        >
          <ul
            :class="{ _open: toggle.indexOf(idx) >= 0 }"
            class="navbar__submenu"
            role="menu"
          >
            <li
              v-for="(subItem, idx2) in parentItem.item"
              :key="idx2"
              class="navbar__submenu-item"
              role="none"
            >
              <template>
                <a :href="getMenuLink(subItem.link)" role="menuitem">{{
                  subItem.nazwa
                }}</a>
              </template>
            </li>
          </ul>
        </div>
      </li>
    </ul>
    <div class="navbar__tools ml-auto mr-6">
      <div class="d-flex">
        <div class="navbar__tools-search-field">
          <span class="search-spinner">
            <loading-spinner :size="18" />
          </span>

          <form
            action="/oferta/szukaj.xml"
            method="get"
            class="search-form h-100"
          >
            <input
              class="navbar__tools-search-input"
              id="hotels-search"
              placeholder="Szukaj hotelu po nazwie..."
              type="search"
              :class="{ visible: hotelSearchVisible }"
            />
          </form>
        </div>

        <div class="navbar__tools-button ml-12" @click="showHotelSearch">
          <div class="navbar__tools-icon">
            <svg
              v-if="!hotelSearchVisible"
              class="svg-icon__svg"
              width="22"
              height="22"
              focusable="false"
            >
              <use xlink:href="/img/static/svg-sprites.svg#icon-search"></use>
            </svg>
            <svg
              v-else
              class="svg-icon__svg"
              width="20"
              height="20"
              focusable="false"
            >
              <use xlink:href="/img/static/svg-sprites.svg#icon-close"></use>
            </svg>
          </div>
        </div>
      </div>

      <div class="d-flex">
        <a
          :aria-label="`Oferty w schowku: ` + clipboardOffersCount"
          href="https://dev.travelone.pl/oferta/schowek.xml"
          title="Schowek ofert"
          class="navbar__tools-button ml-2"
        >
          <span v-if="clipboardOffersCount > 0" class="counter-badge">{{
            clipboardOffersCount
          }}</span>
          <div class="navbar__tools-icon">
            <svg class="svg-icon__svg" width="22" height="22" focusable="false">
              <use xlink:href="/img/static/svg-sprites.svg#icon-heart-o"></use>
            </svg>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { zakladki } from "../zakladki.js";
import { isMobile } from "mobile-device-detect";
import * as CONFIG from "../config.js";

// import jQuery from 'jquery'
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.min.css";

Vue.directive("click-outside", {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!el.contains(event.target)) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent, {
      passive: true,
    });
  },
  unbind: function (el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  },
});

export default {
  name: "desktop-navigation",
  props: {
    clipboardOffersCount: Number,
  },
  data: () => ({
    items: zakladki.zakladki.items,
    toggle: [],
    isMobile: isMobile,
    hotelSearchVisible: false,
  }),
  methods: {
    showHotelSearch() {
      this.hotelSearchVisible = !this.hotelSearchVisible;
    },
    closeItem() {
      this.toggle = [];
    },
    toggleItem(key, e) {
      this.toggle = [key];

      if (this.items[key].item.length > 1 && this.isMobile) {
        e.preventDefault();
      }
    },
    getMenuLink(item) {
      if (item != null && item.indexOf("www.") === 0) {
        return "https://" + item;
      } else {
        return item;
      }
    },
  },
  mounted() {
    initTopMenuAutocompleter(jQuery("#hotels-search"), CONFIG.API_URL);
  },
};

function initTopMenuAutocompleter(selector, api_url) {
  jQuery("#hotels-search").val("");
  selector.autocomplete({
    minLength: 2,
    delay: 200,
    source: function (request, response) {
      jQuery.ajax({
        url: api_url + "/getluparesults.xml",
        dataType: "html",
        crossDomain: true,
        data: { q: request.term },
        success: function (data) {
          let autocompleterResultLayer = jQuery("#ui-id-1");
          let navbarForm = jQuery(".navbar__tools-search-input");
          let xmlObj = jQuery(data);
          let searchItems = xmlObj.children();
          jQuery(".search-spinner").hide();

          showResults(autocompleterResultLayer, searchItems);
          autocompleterResultLayer.css("left", navbarForm.offset().left - 120);
        },
        error: function () {
          alert("ble");
        },
      });
    },
    search: function () {
      jQuery(".search-spinner").show();
    },
    focus: function (event, ui) {
      return false;
    },
    select: function (event, ui) {
      var key = event.which || event.keyCode;
      if (key == 13) {
        var link = jQuery(".ac__all__results");
        if (link.length > 0 && link.is(":visible")) {
          window.location.href = link.attr("href");
        }
        return false;
      }
      return false;
    },
    position: {
      my: "right top",
      at: "right bottom",
    },
  });

  selector.keydown(function (e) {
    var key = e.which || e.keyCode;
    if (key == 13) {
      var link = jQuery(".ac__all__results");
      if (link.length > 0 && link.is(":visible")) {
        window.location.href = link.attr("href");
      }
      return false;
    }
  });

  function showResults(autocompleterResultLayer, view) {
    autocompleterResultLayer.empty();
    autocompleterResultLayer.append(view);
    autocompleterResultLayer.show();
    jQuery(".ui-helper-hidden-accessible").remove();
  }
}
</script>

<style lang="scss">
.ui-autocomplete {
  top: 130px !important;
  width: 31.25em;
  z-index: 1035;
}

.ui-widget.ui-widget-content {
  @include shadow();
  border: 1px solid $border-color;
  border-radius: 3px;
  overflow: hidden;
}

.ui-menu-item {
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: $gray-00;
  }
}

.ac__item {
  border-bottom: 1px solid $border-color;
  display: block;
  overflow: hidden;
  padding: 16px 16px 18px 132px;
  position: relative;

  &:hover {
    color: $text-color-default;
    text-decoration: none;
  }
}

.ac__thumbnail {
  position: absolute;
  top: 16px;
  left: 16px;
  max-width: 100px;
}

.ac__title__block {
  line-height: 1.1;
  margin-top: -2px;
  margin-bottom: 4px;
}

.ac__title {
  @include font-m();
  color: $text-color-default;
}

.ac__breadcrumb,
.ac__touroperator {
  color: $gray-40;
  display: block;
  font-size: 13px;
  line-height: 1.25em;
}

.ac__price {
  @include font-m();
  font-size: 18px;
  position: absolute;
  right: 16px;
  bottom: 14px;
}

.ac__person {
  color: $gray-40;
  font-size: 13px;
}

.ui-widget-content a.ac__all__results {
  color: $link-color;
  display: block;
  padding: 16px;
  text-align: center;
}

.search-top-query-no-results {
  padding: 36px;
  text-align: center;
}

.search-spinner {
  display: none;
  position: absolute;
  top: 0;
  right: 28px;
  bottom: 0;
}

.ui-helper-hidden {
  display: none;
}

.navbar {
  display: flex;
  height: 50px;
  margin-left: -12px;
  margin-right: -12px;
  position: relative;

  &__menu,
  &__submenu {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  &__menu {
    display: inline-flex;
    height: 100%;
  }

  &__menu-item {
    display: flex;

    > a {
      color: #fff;
      display: inline-flex;
      align-items: center;
      padding: 16px 12px;
      text-decoration: none;
      transition: all 0.15s ease-in-out;

      &._active {
        background-color: darken($blue-dark, 8%);
      }
    }
  }

  &__submenu {
    display: flex;
    flex-wrap: wrap;
    padding: 12px 0 16px;
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    transition: opacity 0.2s linear;

    &._open {
      max-height: 500px;
      opacity: 1;
      transition: opacity 0.2s linear;
    }
  }

  &__submenu-item {
    flex: 0 0 percentage($number: 1/3);

    @media (min-width: $screen-lg) {
      flex: 0 0 25%;
    }

    > a {
      border-radius: 2px;
      display: block;
      margin: 0 8px;
      padding: 4px 8px;
      text-decoration: none;

      &:hover,
      &:active {
        background-color: darken($blue-dark, 8%);
      }
    }

    &:first-child {
      display: flex;
      flex: 0 0 100%;
      margin-bottom: 12px;

      > a {
        @include font-m();
        color: $yellow-default;
        flex: 0 0 calc((percentage(1/3)) - 16px);
        padding-top: 6px;
        text-transform: uppercase;
        white-space: nowrap;

        @media (min-width: $screen-lg) {
          flex: 0 0 calc(25% - 16px);
        }
      }
    }

    &:not(:first-child) {
      > a {
        color: #fff;
      }
    }
  }

  &__submenu-wrapper {
    background-color: $blue-dark;
    left: 0;
    margin-top: 6px;
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    width: 100%;
    top: 100%;
    z-index: 1060;

    &._open {
      border-radius: 0 0 3px 3px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.35);
      opacity: 1;
      overflow: visible;
      padding: 12px;
      max-height: 500px;

      &::before {
        content: "";
        display: block;
        position: absolute;
        right: 1px;
        left: 1px;
      }

      &::before {
        height: 6px;
        top: -6px;
      }
    }
  }

  &__tools {
    display: flex;
    padding-top: 8px;
    padding-bottom: 8px;
  }

  &__tools-search-field {
    position: relative;
    overflow: hidden;
  }

  &__tools-search-input {
    background-color: #ffffff;
    border: 0;
    border-radius: 3px;
    height: 100%;
    width: 0;
    opacity: 0;
    padding: 4px 0px;
    transition: width 0.4s cubic-bezier(0, 0.795, 0, 1),
      opacity 0.2s ease-in-out, padding 0.2s ease-in-out;

    &.visible {
      opacity: 1;
      width: 300px;
      padding: 4px 8px;
    }

    &:focus-visible {
      outline: 0;
    }
  }

  &__tools-button {
    color: #ffffff;
    cursor: pointer;
    position: relative;
    width: 36px;
    transition: color 0.15s ease-in-out;

    .counter-badge {
      background-color: #eb3e27;
      border-radius: 16px;
      color: #ffffff;
      display: block;
      font-size: 10px;
      line-height: 1;
      height: 16px;
      min-width: 16px;
      padding: 3px;
      position: absolute;
      right: 0;
      top: 2px;
      text-align: center;
      z-index: 1;
    }

    &:hover {
      color: $blue-light;
      text-decoration: none;
    }
  }

  &__tools-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    position: relative;
  }
}
</style>
